// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2dW6x","tab":"Tabs_tab__3QpxY","tabActive":"Tabs_tabActive__2Qof2"};